"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DataColumns;
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var useStyles = (0, _makeStyles.default)({
  text: {
    '& a': {
      display: 'inline-block',
      maxWidth: '100%',
      overflowWrap: 'break-word',
      verticalAlign: 'top'
    },
    lineHeight: '24px',
    overflowWrap: 'break-word'
  }
});
function DataColumns(_ref) {
  var _ref$alignItems = _ref.alignItems,
    alignItems = _ref$alignItems === void 0 ? 'center' : _ref$alignItems,
    _ref$titleClassName = _ref.titleClassName,
    titleClassName = _ref$titleClassName === void 0 ? '' : _ref$titleClassName,
    id = _ref.id,
    columns = _ref.columns,
    translationKey = _ref.translationKey;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 2
  }, columns.map(function (col, i) {
    return /*#__PURE__*/_react.default.createElement(_material.Grid, {
      key: col.key,
      id: "".concat(id).concat(i),
      item: true,
      md: 12 / columns.length,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      alignItems: alignItems,
      container: true,
      spacing: 1
    }, col.rows.map(function (_ref2, j) {
      var key = _ref2.key,
        _ref2$nonTextual = _ref2.nonTextual,
        nonTextual = _ref2$nonTextual === void 0 ? false : _ref2$nonTextual,
        value = _ref2.value;
      return value && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: key
      }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
        item: true,
        xs: 5
      }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
        className: (0, _classnames.default)(classes.text, titleClassName),
        id: "".concat(id).concat(i, "[").concat(j, "]Title"),
        variant: "body2"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: translationKey ? "".concat(translationKey, ".").concat(key) : key
      }))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
        item: true,
        xs: 7
      }, nonTextual ? value : /*#__PURE__*/_react.default.createElement(_material.Typography, {
        className: classes.text,
        id: "".concat(id).concat(i, "[").concat(j, "]Value"),
        variant: "body2"
      }, value)));
    })));
  }));
}